<template>
  <div ref="root" class="activity-feed">
    <f7-block class="block">
      <activity-feed-entry v-for="(entry, index) in activityEntries"
                           :key="index"
                           :entry="entry"
      />
    </f7-block>
    <div class="comment-input-bar" ref="commentInputBar">
      <comment-input v-model="comment" @comment="saveComment"/>
    </div>
  </div>
</template>

<script>
  import api from 'aio-api'
  import ActivityFeedEntry from '@/components/ActivityFeedEntry'
  import CommentInput from '@/components/CommentInput'
  import moment from 'moment'
  import helpers from '@/utils/helpers'
  import {contiguousGroupBy} from '@/utils/group'

  function sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  const entryGrouper = a => {
    if (a.type.startsWith('tag-')) {
      // convert to string so "===" will compare things correctly
      return ['tag-', a.user, a.created].join(', ')
    }
    return a
  }

  const groupTransform = group => {
    if (group.length === 1) {
      return group[0]
    }
    return {
      type: 'tag-set',
      user: group[0].user,
      created: group[0].created,
      added: group.filter(e => e.type === 'tag-added'),
      removed: group.filter(e => e.type === 'tag-removed'),
    }
  }

  export default {
    mixins: [helpers],
    name: 'ActivityFeed',
    props: {
      requestId: Number,
    },
    components: {CommentInput, ActivityFeedEntry},
    data: () => ({
      comment: '',
      activity: [],
    }),
    methods: {
      async saveComment () {
        const entry = {created: moment().valueOf(), type: 'comment', user: this.currentUserId, body: this.comment}
        api.postRequestComment(this.requestId, this.comment)
        this.comment = ''
        this.activity.unshift(entry)
      },
      async updateActivity () {
        this.activity = (await api.getRequestActivity(this.requestId)).reverse()
      },
      async foreverPoll () {
        // update every ten seconds
        // todo: switch to websockets when viable
        while (this.exists) {
          await this.updateActivity()
          await sleep(10000)
        }
      },
    },
    async mounted () {
      this.exists = true
      if (this.requestId) {
        this.foreverPoll()
      }
      await this.$nextTick()
      // Let us scroll all the way down so the comment input isn't hiding the bottom comment
      this.$refs.root.style.paddingBottom = `${this.$refs.commentInputBar.clientHeight}px`
    },
    destroyed () {
      this.exists = false
    },
    computed: {
      activityEntries () {
        return contiguousGroupBy(this.activity, entryGrouper).map(groupTransform)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .activity-feed .block {
    .md & {
      margin-top: 0;
    }

    .ios & {
    }

    &:first-child {
    }
  }

  @media (max-width: 800px) {
    .comment-input-bar {
      position: fixed;
      z-index: 1000;
      bottom: 1em;
      left: 50%;
      transform: translate3d(-50%, 0, 0);
      width: 90%;
    }
  }
</style>
